import React from 'react';

const Animated = () => (
  <svg viewBox="0 0 70 45">
    <defs>
      <circle id="a" cx="18" cy="22" r="3" />
      <circle id="b" cx="54" cy="25" r="3" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect fill="#409FFF" width="70" height="45" rx="5" />
      <path
        d="M17.026 22.35s9.53 11.25 18 0 18 0 18 0"
        stroke="#FFF"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <use fill="#FFF" xlinkHref="#a" />
      <circle stroke="#3F9FFF" strokeWidth="2" cx="18" cy="22" r="4" />
      <g>
        <use fill="#FFF" xlinkHref="#b" />
        <circle stroke="#3F9FFF" strokeWidth="2" cx="54" cy="25" r="4" />
      </g>
    </g>
  </svg>
);

export default Animated;
